import { Link } from 'react-router-dom';
import { useAuftragCtx } from './AuftragLayout.jsx';
import { useFunktionen } from '../hooks/useFunktionen.js';
import { useBegriffe } from '../hooks/useBegriffe.js';
import { useFormularVorlagen } from '../hooks/data.js';
import { Icon } from '../components/Icon.jsx';

/** Alles, was nicht in die untere Leiste passt: grosse Kacheln (mind. 96 px hoch, handschuhtauglich). */
const BEREICHE = [
  { path: 'kunde', titel: 'tab.kundeninfos', text: 'kachel.kunde.text', icon: 'user', funktion: 'kundeninfos', begriffe: true },
  { path: 'dateien', titel: 'tab.dateienBilder', text: 'kachel.dateien.text', icon: 'folder', funktion: 'dateien', begriffe: true },
  { path: 'zeitplan', titel: 'tab.zeitplan', text: 'kachel.zeitplan.text', icon: 'cal', funktion: 'zeitplan', begriffe: true },
  { path: 'checkliste', titel: 'Übersichtslisten', text: 'Zonen und Anlage abhaken', icon: 'check', funktion: 'uebersichtsliste' },
  { path: 'plaene', titel: 'Bewässerungspläne', text: 'Programme und Laufzeiten', icon: 'clock', funktion: 'bewaesserungsplan' },
];

export function Mehr() {
  const { base } = useAuftragCtx();
  const hat = useFunktionen();
  const b = useBegriffe();
  // Formulare aus Vorlagen (z. B. Abnahme) – Übersichtsliste und Bewässerungsplan haben oben ihre eigene Kachel
  const formulare = (useFormularVorlagen().data ?? []).filter((v) => !BEREICHE.some((x) => x.funktion === v.modul))
    .map((v) => ({ path: `formulare/${v.id}`, titel: v.mehrzahl, text: v.kurz, icon: v.icon, funktion: v.modul }));
  const bereiche = [...BEREICHE.filter((x) => hat(x.funktion)).map((x) => (x.begriffe ? { ...x, titel: b(x.titel), text: b(x.text) } : x)), ...formulare];
  return (
    <nav aria-label="Weitere Bereiche des Auftrags" className="mehrgrid">
      {bereiche.map((x) => (
        <Link key={x.path} to={`${base}/${x.path}`} className="card mehrkachel">
          <span className="mehrico"><Icon name={x.icon} size={26} stroke={2.2} /></span>
          <span className="stack" style={{ gap: 2 }}>
            <span className="h2">{x.titel}</span>
            <span className="sub">{x.text}</span>
          </span>
          <Icon name="chevron" size={20} stroke={2.4} style={{ marginLeft: 'auto', color: 'var(--muted-2)', flexShrink: 0 }} />
        </Link>
      ))}
    </nav>
  );
}
